var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1256,
    viewBox: "0 0 1440 1256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-491.598 1157.95C-495.543 1134.68 -482.122 792.904 -357.782 509.924C-246.168 256.266 13.3835 111.697 317.161 294.01C642.648 489.404 923.401 509.053 1149.78 452.055C1373.2 395.545 1521.77 225.274 1588.5 116.699C1733.32 -117.933 1947.25 27.1989 1872.1 335.907C1836.65 479.51 1743.18 519.659 1581.21 534.56C1411.91 550.135 1161.78 517.074 814.835 584.45C480.245 649.682 103.719 806.345 -108.006 1005.76C-333.333 1218.16 -458.564 1361 -491.598 1157.95Z",
    fill: "url(#paint0_linear_1239_5491)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_5491",
    x1: 1764,
    y1: 973.32,
    x2: -440.332,
    y2: 290.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1877F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E51E25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b46d65222c8e57385bab964a79e7349b.svg";
export { ForwardRef as ReactComponent };